import axios from 'axios'
import store from "../store/store"
import { CONFIGS } from '../configs'

export default {
  getToken(data) {
    return axios.post(CONFIGS.API_SERVER + '/api/token/', data)
  },
  logout() {
    store.commit('logout')
  },
  changePassword(data) {
    return axios.post(CONFIGS.API_SERVER + '/api/user/change_password/', data)
  },
  confirmPassword(data) {
    return axios.post(CONFIGS.API_SERVER + '/api/user/confirm_password/', data)
  }
}
